export function getAutofillOperationName(name: string): string {
	switch (name) {
		case '*':
			return 'Any';
		case 'newBusiness':
			return 'New Business';
		case 'endorsement':
			return 'Endorsement';
		case 'renewal':
			return 'Renewal';
		case 'create':
			return 'Create';
		case 'update':
			return 'Update';
		default:
			return name;
	}
}
